/** ログ抽象レイヤー（Phase 3 で Sentry に差し替え） */
export const logger = {
  error: (message: string, context?: unknown) => {
    if (context !== undefined) {
      console.error(message, context);
    } else {
      console.error(message);
    }
  },
};
